import React, {Component} from "react";
import {Button} from "react-bootstrap";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import { updateSurveyPersonDetails } from "../../survey-actions"


class SaveRecipientDataForm extends Component {

    // eslint-disable-next-line
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            showPersonalError: false,
            fields: { name: '', phone: '', email: ''},
        }
        
        this.handleFormChange = this.handleFormChange.bind(this);
    }

    handleFormChange(e) {
      let fields = this.state.fields;
      fields[e.target.name] = e.target.value;
      this.setState({
        fields
      });
    }  
    
    validatePersonalForm = async(ev) => {
        ev.preventDefault();
        if (this.state.fields.name.length>0 || this.state.fields.phone.length>0 || this.state.fields.email.length>0) {
            this.setState({ showPersonalError: false});
            this.props.updateSurveyPersonDetails(this.props.tvClient,this.props.surveyUrl, this.state.fields.name, this.state.fields.phone, this.state.fields.email).then(()=>{
                document.getElementById("myPersonalDetailsContainer").hidden = true;
            })
        } else {
            // Need to add a message
            this.setState({ showPersonalError: true});
        }
    }

    render() {
        const { data } = this.state;
        return (

      <div id="myPersonalDetailsContainer">
            <form id='myPersonalDetails' onSubmit={this.validatePersonalForm.bind(this)}>
              <h4>Add Your Details:</h4>
              <div>
              <label htmlFor="name">Name:</label>
              <input type="text" id="name" name="name" placeholder="Enter your name" value={this.state.fields.name} onChange={this.handleFormChange} />
              </div>
              <div>
              <label htmlFor="phone">Mobile #:</label>
              <input type="tel" id="phone" name="phone" placeholder="Enter your mobile number" value={this.state.fields.phone} onChange={this.handleFormChange} />
              </div>
              <div>
              <label htmlFor="email">Email:</label>
              <input type="email" id="email" name="email" placeholder="Enter your email address" value={this.state.fields.email} onChange={this.handleFormChange} />
              </div>
              <button type="submit" className="btn btn-primary submitInfoBtn">Submit</button>
            </form>
            {(this.state.showPersonalError) && <p>Please enter at least one value for name, phone, or email</p>}
          </div>

          
        )

    }
}

SaveRecipientDataForm.propTypes = {
    surveyUrl: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return {
        tvClient: state.login.tvClient
    };
};

export default connect(mapStateToProps, {updateSurveyPersonDetails})(SaveRecipientDataForm);

